import { useState } from "react";
import { TopBar } from "./TopBar";
import { Sidebar } from "./Sidebar";
import styles from "./AppLayout.module.css";

export function AppLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className={styles.shell}>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <TopBar onMenuToggle={() => setSidebarOpen((v) => !v)} />
      <div className={styles.body}>
        <Sidebar open={sidebarOpen} onNavigate={() => setSidebarOpen(false)} />
        <main id="main-content" className={styles.main} tabIndex={-1}>
          {children}
        </main>
      </div>
    </div>
  );
}
